<script lang="ts">
    import Container from "../containers/Container.svelte";
    import Image from "../elements/Image.svelte";
    import CTA from '../elements/CTA.svelte';
    import sanityImage from "../../sanity/sanityImage";
    import ParagraphBlock from "../elements/ParagraphBlock.svelte";
    import ReviewStars from "../elements/ReviewStars.svelte";
    export let heading: string;
    export let description: string;
    export let image: any;
    export let ctas : {text: string; url:string; theme : 'filled' | 'outlined-blue' | 'outlined-white' }[] = []
    export let reviewRating : any = null
    export let title : string = ''
</script>


<Container background="navy" padding="none">
    <div class="hero">
       <div class="hero__content">
            <h1>{@html heading}</h1>
            <ParagraphBlock paragraphItems={description}/>
            <div class="hero__cta">
                {#if ctas.length}
                    {#each ctas as cta}
                        <CTA text={cta.text} url={cta.url} theme={cta.variant}/>
                    {/each}
                {:else}
                    <CTA text="Get access to developers" url="https://www.offerzen.com/hire/get-started"/>
                    <CTA text="Book a demo" url="https://www.offerzen.com/hire/book-call" theme="outlined-blue"/>
                {/if}

            </div>
            {#if reviewRating}
                <div class="hero__rating">
                    <div class="hero__rating-images">
                        <ReviewStars stars={reviewRating.rating_stars}/>
                    </div> 
                    <p>Clients rate OfferZen {title}s {reviewRating.rating_copy}/5</p>
                </div>
            {/if}
        </div>
        <Image
            pngUrl={sanityImage(image.asset._ref)}
            webpUrl={sanityImage(image.webp_image.asset._ref)}
            pngUrlMobile={sanityImage(image.mobile.image.asset._ref)}
            webpUrlMobile={sanityImage(image.mobile.webp_image.asset._ref)}
            alt="OfferZen mascots"
            height="inherit"
            loading="eager"
        />
    </div>
</Container>
<style lang="postcss">
@import '../../styles/_mixins.css';
.hero {
    display: flex;
    align-items: center;
    justify-content: center;
    @mixin containerWidth;
    padding: 190px 0 0px;
    gap:80px;
    @mixin screen-xl {
        gap:70px;
    }
    @mixin screen-lg {
        gap:20px;
        padding: 120px 80px 0;
    }
    @mixin screen-md {
        flex-direction:column;
        gap:40px;
        padding: 100px 60px 0px;
    }
    @mixin screen-sm {
        padding:80px 24px 0;
    }
    & .hero__content {
        max-width:700px;
        @mixin screen-lg {
            max-width: 450px;
            max-width: 550px;
        }
        @mixin screen-md {
            width:100%;
        }
        @mixin screen-sm {
            display:flex;
            flex-direction:column;
            text-align:left;
            align-items:flex-start;
            max-width:100%;
        }
        & h1 {
            margin-top: 30px;
            margin-bottom: 24px;
            color: var(--color_white);
            font-size: 55px;
            line-height: 120%;
            font-weight: 700;
            max-width:530px;
            & :global(span) {
                color: var(--color_offerzen_cerulean)
            }
            @mixin screen-md {
                font-size:48px;
                margin-top:80px;
            }
            @mixin screen-sm {
                font-size:40px;
                margin:40px 0 24px;
            }
        }
        & :global(p) {
           @mixin paragraph;
            margin: 0 0 24px;
            color: var(--color_offerzen_lightblue_secondary);
            max-width: 480px;
        }
        & .hero__cta {
            display:flex;
            gap:24px;
            @mixin screen-sm {
                flex-direction: column;
                width:100%;
            }
        }
        & .hero__rating {
            display: flex;
            align-items: center;
            margin:24px 0 0;
            gap:8px;
            
            & .hero__rating-images {
                display:flex;
                align-items: center;
    
                & :global(img) {
                    display: flex;
                    align-items: center;
                    aspect-ratio: 1;
                    height:18px;
                    @mixin screen-sm {
                        margin:0 0 10px;
                    }
                }
            }

            & p {
                margin:2px 0 0;
                font-size:16px;
                line-height: 0;
            }

            @mixin screen-sm {
               flex-direction:column;
               align-items:flex-start;
            }
        }
    }
    & :global(img) {
        max-width:550px;
        display: block;
        aspect-ratio: 3/2;
        @mixin screen-lg {
            max-width:350px;
        }
        @mixin screen-md {
            display:none;
        }
        @mixin screen-sm {
            display:block;
            width:100%;
            aspect-ratio:4/2;
        }
    }
}
</style>